export default __webpack_public_path__ + "static/media/13.6ffc9ca8.jpg";